import React from 'react';
import BoxSelect from '../../lib/BoxSelect/BoxSelect';
import FormWizard from '../FormWizard/FormWizard';

interface IChangeBookingOptionsWizardProps {
  open?: boolean;
  drawerView?: boolean;
  onClose?: (e?: any) => void;
  onFinish?: (e?: any, f?: any, option?: string) => void;
}

const ChangeBookingOptionsWizard: React.FC<React.PropsWithChildren<React.PropsWithChildren<IChangeBookingOptionsWizardProps>>> =
  ({ open, drawerView, onClose, onFinish }) => {
    function onSelect(e) {
      const option = e.target.value;
      onFinish?.(e, null, option);
    }

    return (
      <FormWizard
        open={open}
        onBack={onClose}
        drawerView={drawerView}
        title="What would you like to Change?"
        nextBtnLabel="Submit"
        hideClearBtn
      >
        <div className="grid gap-5">
          {[
            {
              title: 'Change Date / Time',
              subTitle: 'Request a change of date and/or time for your booking',
              value: 'reschedule',
            },
            {
              title: 'Change Services / Number of People',
              subTitle:
                'Request a change of services or a change in the number of people',
              value: 'change package',
            },
          ].map((item, index) => (
            <BoxSelect
              titleClassName="lg:text-white"
              subTitleClassName="lg:text-gray-300"
              key={index}
              value={item.value}
              title={item.title}
              subTitle={item.subTitle}
              onChange={onSelect}
              checkboxType="radio"
            />
          ))}
        </div>
      </FormWizard>
    );
  };
export default ChangeBookingOptionsWizard;
